<template>
  <div class="selectGoodsDialog">
    <el-dialog
      title="选择商品"
      :visible.sync="selectGoodsVisible"
      :selectGoods="selectGoods"
      center
      custom-class='selectGoodsBox'
      width="1200px"
      :before-close="handleClose"
    >
      <div class="chooseGoods">
        <div class="chooseLeft" v-loading='loadingLeft'>
          <el-select v-model="goodType" placeholder='请选择商品分类' @change="selectChange">
            <el-option :label='item.label' :value='item.value' :key="index"
                       v-for="(item,index) in goodTypeOptions"></el-option>
          </el-select>
          <div class="goodTypeArea">
            <div class="goodTypeItem" :key="index" v-for="(item,index) in goodTypeItemList"
                 @click="goodTypeItemClick(item,index)"><span
              :class="currentIndex===index?'goodTypeItem-click':''">{{ item.label }}</span></div>
          </div>
        </div>
        <div class="chooseRight" v-loading='loadingRight'>
          <!-- <el-select v-model="filtrateType">
            <el-option :label='item.label' :value='item.value' :key="index" v-for="(item,index) in filtrateTypeOptions"></el-option>
          </el-select> -->
          <el-input placeholder='请输入内容' v-model="searchContent" clearable></el-input>
          <el-button type='primary' @click="search()">查询</el-button>
          <div class="tableContent">
            <SimpleTable ref="goodsTable"
                         :type='"selection"'
                         :tableStyleName='"dialogTable"'
                         :tableDataTitle='tableGoodsTitle'
                         :tableDataP='tableGoodsData'
                         :showPagination='true'
                         :pageTotal='pageTotal'
                         :currentPageSize="10"
                         :prepositiveSelects='prepositiveSelects'
                         @whole-select='wholeSelect'
                         @page-change='pageChange'
            >
              <el-table-column width='320px' slot='goodsName' label="商品名称">
                <template slot-scope="scope">
                  <div class="goodsNameContainer">
                    <p>{{ scope.row.goodsName }}</p>
                    <p>{{ scope.row.barCode }}</p>
                  </div>
                </template>
              </el-table-column>

            </SimpleTable>
          </div>
        </div>
      </div>
      <div class="footerBtn" style="margin: 10px 0;">
        <el-button type='primary' @click="goodsConfirm()">保存</el-button>
        <el-button type='default' @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SimpleTable from '@/components/template/simpleTable.vue'
import api from '@/config/api'

export default {
  data() {
    return {
      beforeData: [],
      prepositiveSelects: [],
      loadingLeft: false,
      loadingRight: false,
      pageTotal: 0,
      currentIndex: 0,
      currentItem: {},//当前左侧点击的项，为点击分页查询做参数准备
      goodType: 'A01',
      filtrateType: '',
      searchContent: null,//搜索内容
      goodTypeOptions: [
        {label: '分类', value: 'A01'},
        {label: '供应商', value: 'A02'},
        {label: '品牌', value: 'A03'},
      ],
      filtrateTypeOptions: [
        {label: '综合筛选', value: ''},
        {label: '商品名称', value: 'A01'},
        {label: '商品条形码', value: 'A02'},
        {label: '商品货号', value: 'A03'},
        {label: '商品助记号', value: 'A04'}
      ],
      goodTypeItemList: [],
      tableGoodsTitle: [
        {
          label: '商品名称',
          slot: 'goodsName',
        },
        {
          label: '商品类别',
          prop: 'goodsCategories',
        },
        {
          label: '供应商',
          prop: 'supplier'
        },
        {
          label: '品牌',
          prop: 'brand'
        },
        {
          label: '进行中活动',
          prop: 'progressActivity',
          width: '110'
        },
        {
          label: '零售价',
          prop: 'retailPrice',
          width: '90'
        }
      ],
      tableGoodsData: [
        {
          id: '',
          barCode: '',
          goodsName: '',
          purchasingPrice: '',
          retailPrice: '',
          promotionSale: Number(0),
          goodsCategories: '',
          supplier: '',
          brand: '',
          progressActivity: '',
        }
      ]
    }
  },
  components: {
    SimpleTable
  },
  props: ['selectGoodsVisible', 'lastTableData', 'searchParams', 'isParticipate', 'selectGoods'],
  created() {
    this.getAllEnumeration();
    console.log(this.selectGoods);
    this.prepositiveSelects = [...this.lastTableData]
    //创建的时候判断selectGoods 是否为空，如果不为空的话，就赋值给第三变量
    if (this.selectGoods) {
      this.prepositiveSelects=this.selectGoods;
      this.beforeData = this.selectGoods;
    }
    this.goodTypeItemClick({label: '全部', value: ''}, 0)
  },
  methods: {
    selectChange(value) {
      switch (value) {
        case "A01":
          this.getAllEnumeration();
          break;
        case "A02":
          this.getBrandList();
          break;
        case "A03":
          this.getSupplierList();
          break;
      }
    },
    // 品牌
    getBrandList() {
      this.goodType = "A02";
      this.goodTypeItemList = [];
      this.$axios
        .fetchPost(api.archives.brand + "/list", {})
        .then((data) => {
          this.loading = false;
          if (data.code === 200) {
            for (let i = 0; i < data.data.length; i++) {
              let objectAdaptor = {
                value: data.data[i].id,
                label: data.data[i].name || '脏数据'
              };
              this.goodTypeItemList.push(objectAdaptor);
            }
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
    },
    // 供应商
    getSupplierList() {
      this.goodType = "A03";
      this.goodTypeItemList = [];
      this.$axios
        .fetchPost(api.archives.supplier + "/list", {})
        .then((data) => {
          this.loading = false;
          if (data.code == 200) {
            for (let i = 0; i < data.data.length; i++) {
              let objectAdaptor = {
                value: data.data[i].id,
                label: data.data[i].name || '脏数据'
              }
              this.goodTypeItemList.push(objectAdaptor);
            }
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
    },

    search(currentPage = 1, currentSize = 10) {
      let url;
      if (this.searchParams.schemeUrl) {
        url = this.searchParams.schemeUrl;
      } else {
        url = api.promotion.goods + '/page';
      }
      let data = {
        otherName: this.searchContent == "" ? null : this.searchContent,
        pageNumber: currentPage,
        pageSize: currentSize,
        statusList: [10, 30],
      }
      this.tableGoodsData = [];
      this.loadingRight = true;
      this.$axios.fetchPost(url, data).then((res) => {
        if (res.code === 200) {
          this.loadingRight = false;
          let data = res.data.records;
          this.pageTotal = res.data.total
          for (let i = 0; i < data.length; i++) {
            let objectAdaptor = {
              selectable: data[i].activityId ? false : true,
              goodsId: data[i].id,
              goodsCategoryId: data[i].goodsCategoryId,
              barCode: data[i].barCode,
              goodsName: data[i].goodsName,
              purchasingPrice: data[i].purchasePrice,
              retailPrice: data[i].retailPrice,
              promotionSale: Number(0.00),
              disAfterPrice: Number(0.00),
              goodsCategories: data[i].goodsCategoryName,
              supplier: data[i].supplierName,
              brand: data[i].goodsBrandName,
              progressActivity: data[i].activityName || '--'
            }
            this.tableGoodsData.push(objectAdaptor);
            console.log(this.tableGoodsData);
          }
          this.$nextTick(() => {
            this.$refs.goodsTable.seaSelect(this.lastTableData, this.tableGoodsData, 'barCode');
          })
        } else {
          this.$message.error('商品搜索失败！' + res.errorMsg)
        }
      })
    },
    getAllEnumeration() {
      //商品类别可选项
      let url = api.archives.categoryList + '/list';
      this.loadingLeft = true;
      this.$axios.fetchPost(url).then((res) => {
        this.loadingLeft = false;
        this.goodTypeItemList = [{label: '全部', value: ''}];
        if (res.code === 200) {
          for (let i = 0; i < res.data.length; i++) {
            let objectAdaptor = {
              value: res.data[i].id,
              label: res.data[i].name || '脏数据'
            }
            this.goodTypeItemList.push(objectAdaptor);
          }
        } else {
          this.$message.error('商品类别拉取错误!' + res.errorMsg);
        }
      })
    },
    // 保存
    goodsConfirm() {
      //补充序号字段
      let copyPrepositiveSelects = [];
      for (let i = 0; i < this.prepositiveSelects.length; i++) {
        this.$set(this.prepositiveSelects[i], 'index', i + 1);
        copyPrepositiveSelects.push(this.prepositiveSelects[i]);
      }
      this.$emit('update:selectGoodsVisible', false);
      let clearLength = this.lastTableData.length;
      for (let i = 0; i < clearLength; i++) {
        this.lastTableData.splice(0, 1);
      }
      this.$nextTick(() => {
        copyPrepositiveSelects.map((item) => {
          this.lastTableData.push(item);
        })
      })
    },
    // 点击复选框 选中的数据
    wholeSelect(selection, row) {
      let currentData = [];
      if (this.beforeData.length > 0) {
        if (selection.length > 0) {
          for (let i = 0; i < selection.length; i++) {
            let flag = false;
            for (let j = 0; j < this.beforeData.length; j++) {
              if (this.beforeData[j].barCode === selection[i].barCode) {
                flag = false;
                break;
              } else {
                flag = true;
              }
            }
            if (flag) {
              currentData.push(selection[i]);
            }
          }
        }
        //合并两个数组
        this.selectGoods = [...currentData, ...this.beforeData]
      } else {
        this.selectGoods = selection;
      }
      this.prepositiveSelects = this.selectGoods
      // this.prepositiveSelects=this.$refs.goodsTable.positiveSelect(selection,row,this.lastTableData,'barCode',this.tableGoodsData);
    },
    // 选择商品分类
    goodTypeItemClick(item, index, currentPage = 1, currentSize = 10) {
      this.currentIndex = index;
      this.currentItem = item;
      let url;
      if (this.searchParams.schemeUrl) {
        url = this.searchParams.schemeUrl;
      } else {
        url = api.promotion.goods + '/page';
      }
      let data = {
        pageNumber: currentPage,
        pageSize: currentSize,
        statusList: [10, 30],
        stCreateDttm: this.searchParams.stCreateDttm,
        edCreateDttm: this.searchParams.edCreateDttm
      };
      switch (this.goodType) {
        case "A01":
          data.goodsCategoryId = item.value;
          break;
        case "A02":
          data.goodsBrandId = item.value;
          break;
        case "A03":
          data.supplierId = item.value;
          break;
      }
      this.tableGoodsData = [];
      this.loadingRight = true;
      this.$axios.fetchPost(url, data).then((res) => {
        this.loadingRight = false;
        if (res.code === 200) {
          let data = res.data.records;
          this.pageTotal = res.data.total
          //console.log(this.isParticipate)
          for (let i = 0; i < data.length; i++) {
            let objectAdaptor = {
              selectable: data[i].activityId && this.isParticipate == 'participate' ? false : true, // 商品是否参与活动
              goodsId: data[i].id,
              goodsCategoryId: data[i].goodsCategoryId,
              retaleId: data[i].id,
              barCode: data[i].barCode,
              goodsName: data[i].goodsName,
              relateName: data[i].goodsName,
              purchasingPrice: data[i].purchasePrice,
              buyPrice: data[i].purchasePrice,
              retailPrice: data[i].retailPrice,
              promotionSale: Number(0.00),
              commissionRatio: Number(0.00),
              disAfterPrice: Number(0.00),
              goodsCategories: data[i].goodsCategoryName,
              supplier: data[i].supplierName,
              brand: data[i].goodsBrandName,
              progressActivity: data[i].activityName || '--'
            }
            this.tableGoodsData.push(objectAdaptor);
          }
          this.$nextTick(() => {
            this.$refs.goodsTable.seaSelect(this.lastTableData, this.tableGoodsData, 'barCode');
          })
        } else {
          this.$message.error('商品获取失败！' + res.errorMsg)
        }
      })
    },
    // 下一页
    pageChange(page, pageSize) {
      this.goodTypeItemClick(this.currentItem, this.currentIndex, page, pageSize)
    },
    // 取消
    handleClose() {
      this.$emit('update:selectGoodsVisible', false);
      this.$nextTick(() => {
        this.beforeData.map((item) => {
          this.lastTableData.push(item);
        })
      })
      // this.tableGoodsData = []
      // this.lastTableData = []
    }
  }
}
</script>

<style scoped>
  .chooseGoods {
    height: 60vh;
    display: flex;
    flex-flow: row nowrap;
  }

  >>> .selectGoodsBox {
    /*margin-top: 14vh !important;*/
    /*max-height: 90vh;*/
    height: 80vh;
  }

  .selectGoodsDialog >>> .el-dialog__header {
    margin-bottom: 10px;
  }

  .chooseLeft {
    overflow: auto;
  }

  .chooseLeft .goodTypeArea {
  }

  .chooseLeft .goodTypeItem {
    margin: 0px 0px 0px 24px;
    padding: 8px 0px;
    width: 90px;
    height: 40px;

    /*font-size: 12px;*/
    color: #333;
    cursor: pointer;

  }

  .chooseLeft .goodTypeItem span:hover {
    background-color: #e6f9ff;
  }

  .chooseLeft .goodTypeItem span[class~='goodTypeItem-click'] {
    background-color: #a3e7ff;
  }

  .chooseRight {
    width: 100%;
    padding: 0px 10px;
    overflow: auto;
  }

  .chooseRight .tableContent {
    margin-top: 10px;
  }

  .chooseRight .goodsNameContainer {
    text-align: left;
  }

  .chooseRight .goodsNameContainer p {
    height: 20px;
    line-height: 20px;
  }

  .chooseRight .goodsNameContainer .imgArea {
    width: 60px;
    height: 60px;
    border: 1px solid;
    margin-right: 10px;
  }

  .chooseRight .goodsNameContainer .imgArea img {
    width: 60px;
    height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/page/promotion/promotionTool/SelectGoodsDialog.vue